import styled from "styled-components";

export const Container = styled.div`
  & > div {
    margin-bottom: 3.6rem;
  }
`;
